(function () {
   const viewport = document.getElementById('homeYtViewport');
   const prev = document.getElementById('homeYtPrev');
   const next = document.getElementById('homeYtNext');

   if (!viewport || !prev || !next) return;

   const getScrollStep = () => {
      const track = viewport.querySelector('.home-yt-track');
      const card = viewport.querySelector('.home-yt-card');
      if (!card) return Math.round(viewport.clientWidth * 0.75);

      const gap = track ? parseFloat(window.getComputedStyle(track).gap) || 20 : 20;
      return card.offsetWidth + gap;
   };

   const scrollByStep = (direction) => {
      viewport.scrollBy({ left: direction * getScrollStep(), behavior: 'smooth' });
   };

   prev.addEventListener('click', () => scrollByStep(-1));
   next.addEventListener('click', () => scrollByStep(1));

   viewport.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
         event.preventDefault();
         scrollByStep(-1);
      }

      if (event.key === 'ArrowRight') {
         event.preventDefault();
         scrollByStep(1);
      }
   });
})();
